export default "__VITE_ASSET__95e336a5__"